<template>
  <div id="app">
    <header id="header" class="bg-light-grey" :class="scrollClasses">
      <div class="sticky-header" v-bind:class="{ 'open': menuOpen }" ref="header">
        <Menu />
        <Search ref="search" />
      </div>
    </header>
    
    <main id="main" class="bg-light-grey">
      <transition 
        name="page-swipe"
        mode="out-in"
        v-on:before-leave="beforeLeave"
        v-on:after-enter="afterEnter"
      >
        <router-view />
      </transition>
      <ProgressBar />
    </main>
    
    <Footer />
    <Calculator />
  </div>
</template>

<style src="./assets/css/normalize.css"></style>
<style src="./assets/css/ff.core.css"></style>
<style src="./assets/css/base.css"></style>
<style src="./assets/css/colors.css"></style>
<style src="./assets/css/fonts.css"></style>
<style src="./assets/css/layout.css"></style>
<style src="./assets/css/nav.css"></style>
<style src="./assets/css/calculator.css"></style>
<style src="./assets/css/search.css"></style>
<style src="./assets/css/search.results.css"></style>
<style src="./assets/css/footer.css"></style>
<style src="./assets/css/forms.css"></style>
<style src="./assets/css/home.css"></style>
<style src="./assets/css/faq.css"></style>
<style src="./assets/css/progressbar.css"></style>
<style src="./assets/css/review.css"></style>
<style src="./assets/css/nextsteps.css"></style>
<style src="./assets/css/tests.css"></style>
<style src="./assets/css/transitions.css"></style>
<style src="./assets/css/ie-fix.css"></style>

<script>
import Footer from '@/components/Footer.vue'
import Menu from '@/components/Menu.vue'
import Search from '@/components/Search.vue'
import Calculator from '@/components/Calculator.vue'
import ProgressBar from '@/components/ProgressBar.vue'

export default {
  name: "App",
  components: {
    Footer,
    Menu,
    Search,
    Calculator,
    ProgressBar
  },
  data() {
    return {
      prevHeight: 0,
      nextHeight: 0
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    menuOpen () {
      var menuOpen = this.$store.state.menuIsOpen;
      return menuOpen;
    },
    scrollClasses() {
      var scrollClasses = [];
      var searchActive = this.$store.state.search.inFocus || this.$store.state.search.showTypes ? true : false;
      
      if(this.$route.name === "Home") {
        scrollClasses.push('is-home');
      }
      
      if(this.$store.state.scroll.current >= (this.$store.state.scroll.threshold + 10)) {
        scrollClasses.push('has-scrolled');
      } 
      
      if(this.$store.state.scroll.current >= (this.$store.state.scroll.threshold + 10) && this.$store.state.scroll.direction == 'down' && !searchActive) {
        scrollClasses.push('is-hidden');
      }
      
      return scrollClasses;
    }
  },
  beforeMount() {
    /* Import session tokens */
    let init_state = JSON.parse(window.__INITIAL_STATE__);
    this.$store.commit("setSessionToken",{
      name: init_state.session_token.name,
      value: init_state.session_token.value
    });

    /* Load sample types into store */
    if('global' in init_state.data) {
      this.$store.commit("setGlobal", init_state.data.global);
    } else {
      this.loadGlobal();
    }
    
    /* Load sample types into store */
    if('sampleTypes' in init_state.data) {
      this.$store.commit("setSampleTypes", init_state.data.sampleTypes);
    } else {
      this.loadSampleTypes();
    }
    
    /* Load tests into store */
    if('tests' in init_state.data) {
      this.$store.commit("setTests", init_state.data.tests);
    } else {
      this.loadTests();
    }
    
    
    /* Setup global event listeners */
    var v = this;
    
    document.addEventListener("touchmove", this.updateScroll);
    document.addEventListener("scroll", this.updateScroll);
    window.addEventListener("resize", function(){
      v.updateScreensize();
      v.updateScroll();
      v.updateScrollThreshold();
    });
    
    this.updateScreensize();
    
    // Extract estimates from storage
    let myEstimates = localStorage.getItem('myEstimates');
    
    if(myEstimates) {
      this.$store.commit("loadInEstimates", JSON.parse(myEstimates));
    }
    
    // Extract prefill from storage
    let myPrefill = localStorage.getItem('myPrefill');
    
    if(myPrefill) {
      this.$store.commit("loadInPrefill", JSON.parse(myPrefill));
    }
    
  },
  mounted(){
    this.updateScroll();
    this.updateScrollThreshold();
  },
  methods: {
    beforeLeave(el) {
      // Attach previous router-view height to <main>
      var main = document.getElementById("main");
      main.style.height = getComputedStyle(el).height;
    },
    afterEnter(el) {
      // Attach new router-view height to <main>
      var main = document.getElementById("main");
      main.style.height = getComputedStyle(el).height;
      
      // Attach 'auto' height to <main> after transition is complete
      setTimeout(function(){
        main.style.height = 'auto';
      }, 1000);
    },
    async loadGlobal() {
      // Start loading
      //this.categories.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+"global"). then((response) => {
        this.$store.commit("setGlobal", response.data);
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading important global settings. Please reload page to try again.");
      });
      
      // Finish loading
      //this.categories.loading = false;
    },
    async loadSampleTypes() {
      // Start loading
      //this.categories.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+"tests/categories"). then((response) => {
        this.$store.commit("setSampleTypes", response.data.categories);
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the Sample Types. Please reload page to try again.");
      });
      
      // Finish loading
      //this.categories.loading = false;
    },
    async loadTests() {
      // Start loading
      //this.categories.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+"tests"). then((response) => {
        this.$store.commit("setTests", response.data.tests);
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the Tests. Please reload page to try again.");
      });
      
      // Finish loading
      //this.categories.loading = false;
    },
    updateScreensize() {
      this.$store.commit("setWindowSize");
    },
    updateScroll() {
      this.$store.dispatch("scrollStates");
    },
    updateScrollThreshold() {
      var threshold = this.$refs.header.offsetHeight;
      this.$store.commit("setScrollThreshold",threshold);
    }
  },
  watch:{
    // eslint-disable-next-line
    $route (to, from){
      
      // Scroll to top for all page changes, except those in conditional statement
      if(to.name !== 'FaqArticle') {
        this.$scrollTo('#app', 500, {cancelable: false});
      }
      
      // Remove focus on search bar when page changes
      this.$refs.search.blur();
      this.$store.commit('setSearch', { key: 'inFocus' , val: false });
      this.$store.commit('setSearch', { key: 'showTypes' , val: false });
      
      if(from.name === 'NextSteps' || from.name === 'Prefill') {
        this.$store.commit('setLastEstimatePage', from.path);
      }
      
      // Toggle calculator draw
      var showDraw = this.$store.state.calculator.showDraw;
      
      if(showDraw) {
        this.$store.commit("toggleDrawState", "close");
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, this.$store.state.scroll.current);
      }

    }
  },
  metaInfo: {
    title: "CSBP Soil and Plant Analysis Laboratory",
    titleTemplate: "%s | CSBP Lab",
    meta: [
      {
        property: "og:site_name",
        content: "CSBP Lab"
      },
      {
        property: 'og:type', 
        content: 'website'
      }
    ]
  }
};
</script>
